import React, { useEffect, useRef, useState } from "react";
import {
  Chart,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  BarController,
} from "chart.js";
import { useHistory } from "react-router-dom";

// Register only the components we need
Chart.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  BarController
);

export default function CardBarChart({ info,systemSettings}) {
  const history = useHistory();
  const chartRef = useRef(null);
  const canvasRef = useRef(null);

  const [isDataVisible, setIsDataVisible] = useState(true); // Add this line
  const [isScratched, setIsScratched] = useState(false); // Add this line

  // Ensure onboarded data is fetched using entryDate
  const onboardedData = info?.onboardedEmployees || [];
  const years = onboardedData.map((data) => data.year);
  const onboardedCounts = onboardedData.map((data) => data.onboarded);
  const departedCounts = onboardedData.map((data) => data.departed);

  const config = {
    type: "bar",
    data: {
      labels: years,
      datasets: [
        {
          label: "Onboarded Employees",
          backgroundColor: systemSettings?.mainBackground,
          borderColor:systemSettings?.mainBackground,
          data: onboardedCounts,
          fill: true,
          barThickness: 26,
          borderRadius: {
            topLeft: 5,
            topRight: 5,
            bottomLeft: 0,
            bottomRight: 0,
          },
          borderSkipped: false,
        },
        {
          label: "Departed Employees",
          backgroundColor: "#CBDCDC",
          borderColor: "#CBDCDC",
          data: departedCounts,
          fill: true,
          barThickness: 26,
          borderRadius: {
            topLeft: 5,
            topRight: 5,
            bottomLeft: 0,
            bottomRight: 0,
          },
          borderSkipped: false,
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        title: {
          display: false,
          text: "Onboarded vs Departed Employees by Year",
        },
        tooltip: {
          mode: "index",
          intersect: false,
          callbacks: {
            label: (tooltipItem) => {
              const value = tooltipItem?.raw ?? 0;
              const datasetLabel = tooltipItem.dataset?.label || "";
              return `${datasetLabel}: ${value}`;
            },
          },
        },
        legend: {
          labels: {
            color: "black",
          },
          position: "bottom",
        },
      },
      // onClick: (event, elements) => {
      //   if (elements && elements.length > 0) {
      //     const index = elements[0].index; // Ensure elements[0] exists
      //     const year = years[index];

      //     if (year) {
      //       history.push("/admin/resources", { state: { year } });
      //     }
      //   }
      // },
      scales: {
        x: {
          display: true,
          title: {
            display: true,
            text: "Year",
          },
          grid: {
            display: false,
          },
        },
        y: {
          display: true,
          title: {
            display: true,
            text: "Number of Employees",
          },
          grid: {
            display: true,
            drawBorder: false,
            color: "rgba(33, 37, 41, 0.1)",
          },
        },
      },
    },
  };

  useEffect(() => {
    if (chartRef.current) {
      chartRef.current.destroy(); // Destroy the previous chart instance
    }

    // Set default font
    Chart.defaults.font = {
      family: "Lexend",
      size: 14,
    };

    const ctx = canvasRef.current.getContext("2d");
    chartRef.current = new Chart(ctx, config); // Initialize the chart

    return () => {
      chartRef.current?.destroy(); // Cleanup on unmount
    };
  }, [info]); // Re-render chart when `info` changes

  const handleLegendClick = () => {
    setIsDataVisible(!isDataVisible);
    setIsScratched(!isScratched);
    history.push("/admin/resources", {});
  };

  return (
    <>
      <div
        onclick={handleLegendClick}
        className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded"
      >
        <div className="rounded-t mb-0 px-4 py-3 bg-transparent">
          <div className="flex flex-wrap items-center">
            <div className="relative w-full max-w-full flex-grow flex-1">
              <h2 className="text-blueGray-700 text-xl font-light">
                Onboarded vs Departed Employees
              </h2>
            </div>
          </div>
        </div>
        <div className="p-4 flex-auto">
          <div className="relative h-80">
            <canvas ref={canvasRef}></canvas>
          </div>
        </div>
      </div>
    </>
  );
}
